import React from 'react';
import Dashboard from './generic-dashboard';

export const NonPitchDashboard = ({ firstName, props, children = null }) => (
  <Dashboard
    message={`Thanks, ${firstName}. We have received your information and your home advisor will be in touch shortly.`}
    articles={[
      {
        href: 'the-right-pre-approval-letter-helps-you-get-the-home-you-want',
        title: 'The Right Pre-Approval Letter Helps You Get The Home You Want'
      },
      {
        href: 'mortgage-documentation-checklist',
        title: 'The Ultimate Guide to Everything You Need for a Mortgage'
      },
      {
        href: 'decoding-mortgage-jargon',
        title: 'Decoding Mortgage Jargon'
      }
    ]}
    props={props}
  >
    {children}
  </Dashboard>
);

export default NonPitchDashboard;



// WEBPACK FOOTER //
// ./src/products/shared/non-pitch-dashboard.js